import { render, staticRenderFns } from "./updateDepartment.vue?vue&type=template&id=bf9d433a&"
import script from "./updateDepartment.vue?vue&type=script&lang=js&"
export * from "./updateDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports